import { render, staticRenderFns } from "./component-slider.vue?vue&type=template&id=ca868442&scoped=true&"
import script from "./component-slider.vue?vue&type=script&lang=js&"
export * from "./component-slider.vue?vue&type=script&lang=js&"
import style0 from "./component-slider.vue?vue&type=style&index=0&id=ca868442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca868442",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\erina\\Desktop\\works\\git\\KOUWAQP\\QP_kowa_brand_site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca868442')) {
      api.createRecord('ca868442', component.options)
    } else {
      api.reload('ca868442', component.options)
    }
    module.hot.accept("./component-slider.vue?vue&type=template&id=ca868442&scoped=true&", function () {
      api.rerender('ca868442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/qpkowa/assets/js/vue/component/component-slider.vue"
export default component.exports